import {
  Component, ChangeDetectorRef, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, Input,
} from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Observable ,  Subject, forkJoin, of, merge } from 'rxjs';



import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';

// data, models, helpers
import { publishedToast, unpublishedToast } from 'shared/toaster/toasts';
import { segments } from './segments-list';
import { rightPanelNavs } from './right-panel-navs';
import { SideNavButtonModel } from 'shared/status-sidenav/status-sidenav/side-nav.model';
import { indexPagesData } from 'utils/index-pages-data';
import { setItemDetailValidation } from 'shared/item-detail/item-detail-validation';
import { getAssetThumbnail } from 'shared/digital-assets/digital-asset-helpers';
import * as productHelpers from 'shared/product/product-helpers';
import * as searchPageHelpers from 'shared/search-page/search-page.helpers';
import { ReturnRouteModel } from 'shared/return-route/return-route.model';
import { setUnreadCommentsCount } from 'shared/comments/comments-helpers';
import { DetailsSegment } from './details-segment.interface';
import { SearchModel } from 'shared/search/search.model';
import Bugsnag from '@bugsnag/js';
import { Config } from 'shared/config/env.config';

// components
import { SegmentsNavigationV2Component } from 'shared/segments-navigation/segments-navigation-v2/segments-navigation-v2.component';
import { DynamicNavsComponent } from 'shared/nav/dynamic-navs/dynamic-navs.component';
import { DetailsPageModalComponent } from 'shared/details-page/details-page-modal/details-page-modal.component';
import { SegmentsContainerComponent } from './components/segments-container/segments-container.component';
import { SimpleConfirmModalComponent } from 'shared/modal/simple-confirm-modal/simple-confirm-modal.component';
import { ScorecardDropdownComponent } from 'shared/dropdown/scorecard-dropdown/scorecard-dropdown.component';

// services
// import { SegmentValidationService } from 'shared/validation/segment-validation/segment-validation.service';
import { BrandService } from 'shared/brand/brand.service';
import { ItemDetailService } from 'shared/item-detail/item-detail.service';
import { PriceSheetService } from 'shared/price-sheet/price-sheet.service';
import { ProductGroupsService } from 'shared/product-groups/product-groups.service';
import { MarketingCopyDetailsService } from 'shared/marketing-copy/marketing-copy-details.service';
import { PermissionsService } from 'shared/permissions/permissions.service';
import { ReturnRouteService } from 'shared/return-route/return-route.service';
import { CommentsService } from 'shared/comments/comments.service';
import { PreferencesService } from 'shared/preferences/preferences.service';
import { ScorecardService } from 'shared/scorecard/scorecard.service';
import { ScorecardConnectorService } from 'shared/scorecard/scorecard-connector.service';
import { LogsService } from 'shared/logs/logs.service';
import { statusLookup } from 'shared/my-products/my-products-statuses';
import {filter, first, takeWhile} from 'rxjs/operators';
import { ProcessService } from 'shared/process/process.service';


@Component({
  moduleId: module.id,
  selector: 'sd-product-details',
  templateUrl: 'product-details.component.html',
  styleUrls: ['product-details.component.scss'],
  providers: [ScorecardConnectorService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductDetailsComponent implements OnInit, OnDestroy {

  @Input() bulkEdit: boolean = false;
  @Input() selectedIds: Array<any>;
  @Input() searchModel: SearchModel;
  @Input() listId: string;
  @Input() allSelected: boolean;
  @Input() totalRecords: number;

  itemDetail: any;
  itemDetailSourceData: any;
  priceSheets: any;
  productGroupsData: any;
  productImageUrl: string;
  navigationSegments: Array<DetailsSegment> = segments;
  rightPanelNavs: any[] = rightPanelNavs;
  headerColor: string = '';
  sideNavStatus: string = '';
  sideNavButtons: Array<SideNavButtonModel>;
  showMarketing: boolean = false;
  prevRouteShort: string = '';
  timezone: any;
  selectedScorecard: any = {};
  scorecardsList: Array<any> = [];
  isPageActive: boolean = true;
  closingPageAnimation: boolean = false; // starts close modal animation
  urlWithoutSegment: string;
  scoreData: any;
  scoreSourceData: any;
  scorecardData: any;
  isItemDetailLoading: boolean = false; // indicate item detail fetching from BE
  showSidedrawer: boolean = true;
  isSidedrawerHidden: boolean = true;

  // used in order to show next selected segment
  // before showing save warning modal
  private nextSegment: DetailsSegment;

  // details page modal layout
  @ViewChild(DetailsPageModalComponent, {static: false})
  detailsPage: DetailsPageModalComponent | void;

  // conainer with segments
  // rendering segments, saving data
  // save warning modals
  @ViewChild(SegmentsContainerComponent, {static: false})
  segmentsContainer: SegmentsContainerComponent | void;

  @ViewChild('saveBeforeLeavingModal', {static: false})
  saveBeforeLeavingModal: SimpleConfirmModalComponent | void;

  /*
   * Modal used to warn the user that they are publishing
   * this item with pies scores that are below 100%
   */
  @ViewChild('publishWarningModal', {static: false})
  publishWarningModal: SimpleConfirmModalComponent | void;

  @ViewChild(ScorecardDropdownComponent, {static: false})
  scorecardDropdown: ScorecardDropdownComponent | void;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private ref: ChangeDetectorRef,
    private brandService: BrandService,
    private itemDetailService: ItemDetailService,
    // private segmentValidationService: SegmentValidationService,
    private toastrService: ToastrService,
    private priceSheetService: PriceSheetService,
    private productGroupsService: ProductGroupsService,
    private marketingService: MarketingCopyDetailsService,
    private permissionsService: PermissionsService,
    private commentsService: CommentsService,
    private preferencesService: PreferencesService,
    private returnRouteService: ReturnRouteService,
    private scorecardService: ScorecardService,
    private scorecardConnectorService: ScorecardConnectorService,
    private logsService: LogsService,
    private processService: ProcessService,
  ) {
    _.each(this.navigationSegments, (item: any, index: number) => {
      item.active = index === 0;
    });
  }

  /******************************************/
  /* COMPONENT GETTERS                       */
  /******************************************/
  get updatedDate(): string {
    return _.get(this, 'itemDetail.updated_at', '');
  }

  get lastPublishedDate(): string {
    return _.get(this, 'itemDetail.last_published_at', '');
  }

  get description(): string {
    return productHelpers.getHeaderDescription(this.itemDetail);
  }

  get itemId(): any {
    return _.get(this.route.snapshot.params, 'id', '');
  }

  get routeSegmentName(): string {
    return _.get(this.route.snapshot.params, 'segment', 'overview');
  }

  get brandId(): string {
    return this.brandService.getBrand();
  }

  get partNumber(): string|undefined {
    return _.get(this.itemDetail, 'partNumber');
  }

  get itemStatus(): number {
    return _.get(this.itemDetail, 'status');
  }

  get isEditMode(): boolean {
    return this.detailsPage && this.detailsPage.isEditMode;
  }

  get isFormChanged(): boolean {
    if (this.isEditMode) {
      return _.get(this.segmentsContainer, 'isDirty');
    } else {
      return false;
    }
  }

  get activeSegment(): DetailsSegment {
    return _.get(this.segmentsContainer, 'currentSegment');
  }

  get activeSegmentName(): string {
    return _.get(this.segmentsContainer, 'currentSegment.name');
  }

  get activeSegmentComponent(): any {
    return _.get(this.segmentsContainer, 'activeComponent');
  }

  get dynamicNavs(): DynamicNavsComponent | void {
    return this.detailsPage && this.detailsPage.dynamicNavs;
  }

  get activeTabComponent(): any {
    return this.detailsPage && _.get(this.detailsPage.dynamicNavs, 'componentRef.instance');
  }

  get activeTabName(): string {
    return this.detailsPage && _.get(this.detailsPage.dynamicNavs, 'activeNav.name');
  }

  get segmentsNavigation(): SegmentsNavigationV2Component | void {
    return this.detailsPage && this.detailsPage.segmentsNavigation;
  }

  get bulkSecondaryTitle(): string {
    return this.allSelected ?
      `About ${this.totalRecords} Products selected`
      : `${this.selectedIds.length} Products selected`;
  }

  get isViewEditBtnHidden(): boolean {
    return this.activeSegmentName === 'overview' ||
       _.includes(['published', 'view-export', 'import-review-pies', 'import-review-aces'], this.prevRouteShort) ||
      this.hideFitmentsViewEditBtn ||
      !(
        this.hasPermission(['admin', 'catalog-edit']) ||
        (this.hasPermission(['fitments']) && this.activeSegmentName === 'fitments')
      );
  }

  // edit mode doesn't exist on overview segment
  // so we should show view mode header style instead if edit
  // SPD2-3905
  get isHeaderEditMode(): boolean {
    return this.isEditMode && this.activeSegmentName !== 'overview';
  }

  get isFitmentsResearch(): boolean {
    return this.activeSegmentName === 'fitments' && _.get(this.activeSegmentComponent, 'isResearchMode');
  }

  get hideFitmentsViewEditBtn(): boolean {
    if (this.activeSegmentName === 'fitments') {
      // Only certain permissions can edit fitments
      if (this.hasPermission(['admin', 'fitments']) === false) {
        return true;
      }
      // if users have changed fitments (revisionId exits)
      // then show view/edit button even in spite of research mode
      if (this.isFormChanged) { return false; }
      // if fitments haven't been changed then hide ViewEditBtn in the fitments research mode
      return this.isFitmentsResearch;
    }
    return false;
  }

  /******************************************/
  /* COMPONENT SETTERS                       */
  /******************************************/

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnInit() {
    this.checkUserPermission();
    this.rightPanelNavs[1].data = {itemId: this.itemId, brandId: this.brandId, statusLookup };


    this.returnRouteSetup();
    _.defer(() => {
      const tab = _.get(this.route.snapshot.params, 'tab', 'scorecard');
      if (tab && this.dynamicNavs) { this.dynamicNavs.selectNav(tab); }
      // navs change event
      this.subscribeNavsChange();
    });
    this.setNavigationSegments();
    _.defer(() => {
      if (this.segmentsContainer instanceof SegmentsContainerComponent) {
        this.segmentsContainer.selectSegment(this.routeSegmentName);
      }
    });
    this.fetchPageData();
    this.urlWithoutSegment = this.getPageUrl();

    this.scorecardConnectorService.totalScoreChanged
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((score: any) => {
      // recalculate total score after control become valid/invalid
      this.scoreData.score += score.possible * (score.valid ? 1 : -1);
      this.updateSelectedScorecardProgress(this.scoreData);
    });

    this.router.events
    .pipe(
        filter(event => event instanceof NavigationEnd),
        takeWhile(() => this.isPageActive))
    .subscribe((event: any) => {
      this.checkUserPermission();
      const segment: DetailsSegment = _.find(this.navigationSegments, ['name', this.routeSegmentName]);
      if (!segment) { return; }
      if (this.isFormChanged) {
        this.nextSegment = segment;
        if (this.saveBeforeLeavingModal instanceof SimpleConfirmModalComponent) {
          this.saveBeforeLeavingModal.show();
        }
      } else {
        if (this.segmentsContainer instanceof SegmentsContainerComponent) {
          this.segmentsContainer.selectSegment(segment);
        }
        this.changeScorecard(segment);
        if (this.segmentsNavigation) {
          this.segmentsNavigation.setActive(this.activeSegment.name);
        }
        this.ref.markForCheck();
      }
    });
  }

  ngOnDestroy() {
    this.isPageActive = false;
    this.navigationSegments = [];
    this.itemDetail = null;
    // this.segmentValidationService.resetValidation();
    setUnreadCommentsCount(this.rightPanelNavs, 0);
  }

  /*******************************************
   * COMPONENT HANDLERS
   *******************************************/

  onSegmentSelect(segment: DetailsSegment) {
    this.router.navigate([`../${segment.name}`], { relativeTo: this.route });
  }

  onSaveBeforeLeaving(action: string) {
    switch (action) {
      case 'save':
        if (this.segmentsContainer instanceof SegmentsContainerComponent) {
          this.segmentsContainer.saveChanges();
        }
        break;
      case 'cancel':
        this.nextSegment = null;
        if (this.segmentsNavigation) {
          this.segmentsNavigation.setActive(this.activeSegment.name);
        }
        return this.saveBeforeLeavingModal && this.saveBeforeLeavingModal.hide();
      case 'discard':
        if (this.nextSegment) {
          this.itemDetail = _.cloneDeep(this.itemDetailSourceData);
          if (this.scoreData) {
            this.scoreData = _.cloneDeep(this.scoreSourceData);
          }
          if (this.detailsPage) {
            this.detailsPage.setEditMode(false);
          }
          if (this.activeSegmentName === 'fitments') {
            this.rollbackFitmentsRequest()
            .pipe(takeWhile(() => this.isPageActive))
            .subscribe(() => this.updateLogs());
          }
        }

        if (this.saveBeforeLeavingModal instanceof SimpleConfirmModalComponent) {
          this.saveBeforeLeavingModal.hide();
        }
        _.delay(() => {
          if (this.nextSegment) {
            if (this.segmentsContainer instanceof SegmentsContainerComponent) {
              this.segmentsContainer.selectSegment(this.nextSegment);
            }
            this.changeScorecard(this.nextSegment);
          }
        }, 500);

        break;
    }
  }

  onSideNavButtonClicked(value: any) {
    if (value === 5) {
      if (this.detailsPage instanceof DetailsPageModalComponent) {
        this.detailsPage.showLoader();
      }
      this.itemDetailService.postAcceptImported(this.brandId, this.itemDetail.itemId)
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe( (itemDetail) => {
          // request failed (handleError returns an error string) or answered with an empty body
          if (!_.isPlainObject(itemDetail)) {
            if (this.detailsPage instanceof DetailsPageModalComponent) {
              this.detailsPage.hideLoader();
            }
            this.ref.markForCheck();
            return;
          }

          this.itemDetail = setItemDetailValidation(itemDetail, this.selectedScorecard?.unique_id);
          this.populateSideNavValues(this.itemStatus);
          this.updateLogs();
          if (this.detailsPage instanceof DetailsPageModalComponent) {
            this.detailsPage.hideLoader();
          }
          this.ref.markForCheck();
        });
    } else {
        /*
         * If the item is being published call postItemsValid. The method
         * checks to see if the item's pies scores are 100%.
         */
      if (value === 8) {
          this.postItemsValid(value);
      } else {
          this.updateStatus(value);
      }
    }
  }

  private updateStatus(value: any) {
    if (this.detailsPage instanceof DetailsPageModalComponent) {
      this.detailsPage.showLoader();
    }
      this.itemDetailService.postUpdateStatus(this.brandId, this.itemDetail.itemId, value)
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe( (itemDetail) => {
          // request failed (handleError returns an error string) or answered with an empty body
          if (!_.isPlainObject(itemDetail)) {
            if (this.detailsPage instanceof DetailsPageModalComponent) {
              this.detailsPage.hideLoader();
            }
            this.ref.markForCheck();
            return;
          }

          this.itemDetail = setItemDetailValidation(itemDetail, this.selectedScorecard?.unique_id);
          this.populateSideNavValues(this.itemStatus);
          if (value === 8) {
            this.toastrService.info('', '', publishedToast());
          }
          if (value === 10) {
            this.toastrService.info('', '', unpublishedToast());
            this.closePage();
          }
          if (this.detailsPage instanceof DetailsPageModalComponent) {
            this.detailsPage.hideLoader();
          }
          this.ref.markForCheck();
          this.updateLogs();
        });
  }

  /**
   * Check to see if the item's scores for pies is 100%
   * If it is not 100% then display a warning modal
   * notifying the user.
   */
  private postItemsValid(data: any) {

    const _filter = [];
    const ids = [parseInt(this.itemId)];

    if (this.detailsPage instanceof DetailsPageModalComponent) {
      this.detailsPage.showLoader();
    }

    this.processService.postItemsValid(
      this.brandId, ids, '', _filter, 'working',
    )
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe(
        response => {
          if (this.detailsPage instanceof DetailsPageModalComponent) {
            this.detailsPage.hideLoader();
          }
          const pies65Total = _.get(response, 'invalid-pies-65', 0);
          const pies67Total = _.get(response, 'invalid-pies-67', 0);

          if (pies65Total) {
            console.log('PIES 65 invalid', pies65Total);
          }
          if (pies67Total) {
            console.log('PIES 67 invalid', pies67Total);
          }

          if (pies65Total || pies67Total) {
            if (this.publishWarningModal) {
              this.publishWarningModal.data = data;
              this.publishWarningModal.show();
            }
          } else {
              this.updateStatus(data);
          }
        },
        error => {
          if (this.detailsPage instanceof DetailsPageModalComponent) {
            this.detailsPage.hideLoader();
          }
        }
      );
  }

  /**
   * Method used in the template that tells us, the
   * user wants to publish the item even though
   * it's pies scores are below 100%
   */
  onPublishAnyway(data) {
    this.updateStatus(data);
  }

  onPreviewOptionSelect(item: any) {
    if (item.route === `/${this.route.snapshot.url[0].path}`) { return; }
    this.router.navigate([item.route, this.itemId]);
  }

  onDetailsPageClose() {
    if (this.isFormChanged) {
      this.nextSegment = null;
      if (this.saveBeforeLeavingModal instanceof SimpleConfirmModalComponent) {
        this.saveBeforeLeavingModal.show();
      }
    } else {
      this.closePage();
    }
  }

  onSaveClick() {
    this.nextSegment = null;
    if (this.segmentsContainer instanceof SegmentsContainerComponent) {
      this.segmentsContainer.saveChanges();
    }
  }

  onCancelChangesClick() {
    if (this.activeSegmentName === 'fitments') {
      // rollback fitments changes
      if (this.detailsPage instanceof DetailsPageModalComponent) {
        this.detailsPage.showLoader();
      }
      this.rollbackFitmentsRequest()
      .pipe(takeWhile(() => this.isPageActive))
      .subscribe((response: any) => {
        this.getItemDetail(this.brandId, this.itemId)
        .pipe(
            first(),
            takeWhile(() => this.isPageActive)
        ).subscribe(() => {
          if (this.detailsPage instanceof DetailsPageModalComponent) {
            this.detailsPage.hideLoader();
            this.detailsPage.setEditMode(false);
          }
          this.updateLogs();
        });
      });
    } else {
      this.itemDetail = _.cloneDeep(this.itemDetailSourceData);
      if (this.scoreData) {
        this.scoreData = _.cloneDeep(this.scoreSourceData);
      }
      if (this.segmentsContainer instanceof SegmentsContainerComponent) {
        this.segmentsContainer.updateSegmentData(
          this.itemDetail,
          this.scoreData,
          this.scorecardData,
          this.priceSheets,
        );
      }
      this.changeScorecard(this.activeSegment);
      if (this.detailsPage instanceof DetailsPageModalComponent) {
        this.detailsPage.setEditMode(false);
      }
    }
  }

  onScorecardChange(scorecard: any) {
    this.scorecardService.setSelectedScorecardId(scorecard._id);
    this.setScorecard(scorecard);
  }

  onChangesStartSaving() {
    if (this.detailsPage instanceof DetailsPageModalComponent) {
      this.detailsPage.showLoader();
    }
  }

  onChangesSaved($event: any) {
    if (this.saveBeforeLeavingModal instanceof SimpleConfirmModalComponent) {
      this.saveBeforeLeavingModal.hide();
    }
    _.delay(() => {
      if (this.nextSegment) {
        if (this.segmentsContainer instanceof SegmentsContainerComponent) {
          this.segmentsContainer.selectSegment(this.nextSegment);
        }
        this.changeScorecard(this.nextSegment);
      }
    }, 500);

    // fetch item detail & scorecard here
    this.getItemDetail(this.brandId, this.itemId)
    .pipe(first(), takeWhile(() => this.isPageActive))
    .subscribe(() => {
      if (this.detailsPage) {
        this.detailsPage.hideLoader();
        this.detailsPage.setEditMode(false);
      }
      this.updateLogs();
    });
  }

  onChangesCanceled() {
    // they were canceled in warning modal inside components
    // set active current segment tab
    this.nextSegment = null;
    if (this.segmentsNavigation) {
      this.segmentsNavigation.setActive(this.activeSegment.name);
    }
  }

  /*******************************************
  * COMPONENT PUBLIC METHODS
  *******************************************/

  returnRouteSetup() {
      /*
       * Setup the return route
       */
      let returnRoute = null;

      if (this.itemDetail) {
        returnRoute = this.getDefaultReturnRoute(this.itemStatus);
        this.setMarketingVisibility(returnRoute ? returnRoute.route : '');
      } else {
        returnRoute = this.returnRouteService.peak();
      }
      const prevPage = this.getPrevPage(returnRoute ? returnRoute.route : '');
      // show empty fitments for 'import-review-pies' page
      if (prevPage === 'import-review-pies' && this.itemDetail) {
        this.itemDetail.fitments = [];
      }
      this.setPageSettings(returnRoute ? returnRoute.route : '');
  }

  getDefaultReturnRoute(itemDetailStatus: number) {
    const segment = (!this.permissionsService.hasPermission(['admin', 'catalog-edit', 'fitments'])) ?
      'published' : searchPageHelpers.searchSegment(itemDetailStatus);

    const defaultRoute = '/my-products';
    return new ReturnRouteModel(segment ? `${defaultRoute}/${segment}` : defaultRoute, {smlocal: 1});
  }

  populateSideNavValues(status: number) {
    const values = productHelpers.populateSideNavValues(status, this.prevRouteShort === 'published');
    this.sideNavButtons = [values.sideNavTopButton, values.sideNavBottomButton];
    this.sideNavStatus = values.sideNavStatus;

    if ( !this.permissionsService.hasPermission(['admin', 'catalog-edit'])) {
        values.sideNavTopButton.show = false;
        values.sideNavBottomButton.show = false;
    }
  }

  hasPermission(allow: Array<string>|string, requireAll: boolean= false) {
    return this.permissionsService.hasPermission(allow, requireAll);
  }

  /*******************************************
   * COMPONENT PRIVATE METHODS
   *******************************************/


  private fetchPageData() {
    const { id } = this.route.snapshot.params;
    this.getItemDetail(this.brandId, id)
    .pipe(first(), takeWhile(() => this.isPageActive))
    .subscribe((result: any) => {
      this.updateRightNavs();
      if (this.dynamicNavs && _.get(this.dynamicNavs.activeNav, 'name') === 'comments') {
        this.dynamicNavs.componentRef.instance.fetch(this.brandId, this.partNumber, 'item');
      }

      if (this.segmentsNavigation) {
        if (!this.activeSegment && Config.BUGSNAG_KEY) {
          Bugsnag.notify(new Error('Product navigation id error: Cannot read properties of undefined'));
          return;
        }
        this.segmentsNavigation.setActive(this.activeSegment.name);
      }
    });
  }

  private getItemDetail(brand: string, id: number): Observable<any> {
    this.isItemDetailLoading = true;
    this.ref.markForCheck();
    const subj = new Subject<any>();
    const requests: any = [
      this.itemDetailService.fetchItemDetail(brand, id),
      this.preferencesService.getPreferences(),
      this.productGroupsService.fetch(this.brandId),
      this.marketingService.fetchMarketingCopy(this.brandId, id),
      this.priceSheetService.fetchAll(this.brandId),
      this.scorecardService.getScorecards(this.brandId),
      // this.itemDetailService.fetchItemDetailPackages(brand, id),
    ];
    forkJoin(requests)
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((responseData: Array<any>) => {
      // item detail fetch failed (e.g. 404) — handleError returned an error string
      if (_.isString(responseData[0])) {
        this.isItemDetailLoading = false;
        this.ref.markForCheck();
        this.router.navigate(['/my-products']);
        subj.complete();
        return;
      }

      this.checkItemPermissions(responseData[0]);

      // set itemDetail
      this.itemDetail = setItemDetailValidation(responseData[0]);

      this.productImageUrl = productHelpers.getProductImageUrl(this.itemDetail);

      // set asets photo
      _.forEach(this.itemDetail.digitalAssets, (asset: any) => {
        asset.photo = getAssetThumbnail(asset, 'small');
      });

      // set timezone
      this.timezone = _.get(responseData[1], 'timezone');
      // set product groups
      this.productGroupsData = _.get(responseData[2], 'timezone');
      // set product marketing
      this.itemDetail.marketing = this.groupMarketingData(responseData[3]);
      // set price sheets
      this.priceSheets = responseData[4];

      // set scorecard data
      this.scorecardsList = responseData[5];
      _.each(this.scorecardsList, (item: any) => {
        const total = _.get(this.itemDetail, `scorecards.${item._id}.total`);
        item.progress = total ? Math.floor(total) : null;
      });
      this.ref.markForCheck();

      // set selected scorecard
      // get Score Item data call is below
      const selectedScorecardId = this.scorecardService.getSelectedScorecardId();
      if (selectedScorecardId !== 'off') {
        const selectedScorecard = _.find(this.scorecardsList, {_id: selectedScorecardId});
        if (selectedScorecard) {
          this.selectedScorecard = selectedScorecard;
        }
      }

      // set itemDetail
      this.itemDetail = setItemDetailValidation(responseData[0], this.selectedScorecard?.unique_id);

      // Don’t remove this console.log, it’s for debugging
      console.log(this.itemDetail);
      _.defer(() => this.scorecardDropdown && this.scorecardDropdown.selectScorecardById(selectedScorecardId));

      this.itemDetailSourceData = _.cloneDeep(this.itemDetail);

      /*
       * Setup the return route
       */
      this.returnRouteSetup();

      this.populateSideNavValues(this.itemStatus);

      this.setUnreadCommentsCount();

      // If we have selected scorecard for product -
      // require /api/scorecard & /api/scorecard-item
      if (selectedScorecardId !== 'off' && this.selectedScorecard._id) {
        forkJoin([
          this.scorecardService.getScoreItem(this.itemDetail._id, this.selectedScorecard._id),
          this.scorecardService.getScorecard(this.selectedScorecard._id),
        ])
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe((data: Array<any>) => {
          this.setScorecardData(data[0], data[1]);

          this.changeScorecard(this.activeSegment);
          this.updateSegmentsValidation();
          // sets all data to the segment
          if (this.segmentsContainer instanceof SegmentsContainerComponent) {
            this.segmentsContainer.updateSegmentData(
              this.itemDetail,
              this.scoreData,
              this.scorecardData,
              this.priceSheets,
            );
          }
          this.isItemDetailLoading = false;
          this.ref.markForCheck();
          subj.next(this.itemDetail);
          subj.complete();
        });
      } else {
        this.updateSegmentsValidation();
        // sets all data to the segment
        if (this.segmentsContainer instanceof SegmentsContainerComponent) {
          this.segmentsContainer.updateSegmentData(
            this.itemDetail,
            this.scoreData,
            this.scorecardData,
            this.priceSheets,
          );
        }
        // if scorecard tab is active then show completion off stub
        this.changeScorecard(this.activeSegment);
        this.isItemDetailLoading = false;
        this.ref.markForCheck();
        subj.next(this.itemDetail);
        subj.complete();
      }
    });
    return subj.asObservable();
  }

  private subscribeLogsRollback(logsComponent: any) {
    logsComponent.componentRef.instance.rollbackEnded
    .pipe(takeWhile(() => logsComponent.componentRef.instance.isActive))
    .subscribe((event: any) => {
      this.getItemDetail(this.brandId, this.itemId);
    });
  }

  private subscribeLogsSegmentClick(logsComponent: any) {
    logsComponent.componentRef.instance.segmentClicked
    .pipe(takeWhile(() => logsComponent.componentRef.instance.isActive))
    .subscribe((segmentId: string) => {
      const segment = _.find(segments, {id: segmentId});
      if (segment && segment.name) {
      }
    });
  }

  private getPrevPage(prevRoute: string): any {
    if (!this.permissionsService.hasPermission(['admin', 'catalog-edit', 'fitments'])) {
      return 'published';
    }

    const splittedRoute = prevRoute.split('/');
    let page = splittedRoute.length > 1 ? splittedRoute[2] : null;
    if (prevRoute.indexOf('my-products') === -1 || !page) {
      page = _.get(JSON.parse(localStorage.getItem('myProductsSearchModel')), 'route', '');
    }
    return page;
  }

  private setPageSettings(prevRoute: string) {
    const prevRouteShort = this.getPrevPage(prevRoute);
    this.prevRouteShort = prevRouteShort;

    // set header color - deps from previous page
    const indexPageData = indexPagesData[prevRouteShort];
    this.headerColor = indexPageData ? indexPagesData[prevRouteShort].headerColor : 'darkred';
  }

  private setMarketingVisibility(prevRoute: string) {
    // show for Product & Publish pages
    const pagesWithoutMarketing = [
      'import-review-pies',
      'import-review-aces',
      'view-export',
    ];
    const prevRouteShort = this.getPrevPage(prevRoute);
    this.showMarketing = !(_.indexOf(pagesWithoutMarketing, prevRouteShort) >= 0);

    // change segments tabs
    if (!this.showMarketing) {
      this.navigationSegments = _.filter(segments, (segment: any) => {
        return segment.segment !== 'marketing';
      });
    }
  }

  private updateLogs(): void {
    if (this.dynamicNavs && _.get(this.dynamicNavs.activeNav, 'name') === 'logs') {
      this.dynamicNavs.componentRef.instance.updateLogs();
    }
  }

  private groupMarketingData(data: any) {
    const subSegments = _.keys(data);
    const props = ['code', 'type'];
    const typeOrder: Array<any> = ['GCC', 'FAB'];
    const codeOrder: any = {
      brand: ['BRD', 'BOW', 'BPR', 'SBR'],
      product_groups: ['PGC', 'PSG'],
      part_type: ['PTI', 'PCC'],
    };
    const res: any = {};
    // group by
    _.forEach(subSegments, (subSegment: string) => {
      res[subSegment] = this.groupMarketingItemsByProps(data[subSegment], props, typeOrder, codeOrder[subSegment]);
    });
    return res;
  }

  private groupMarketingItemsByProps(data: Array<any>, props: Array<string>, typeOrder?: Array<string>, codeOrder?: Array<string>) {
    const res: Array<any> = [];
    let orderedData: any[];

    // group data by props
    const common: any = _.pick(data, props);
    // find element with the same fields
    const matchEl = _.find(res, common);
    if (matchEl) {
      // if this element exists - extend copies
      this.extendMarketingItem(matchEl, data);
    } else {
      // if not - create new
      const newItem = this.createMarketingItem(data);
      res.push(newItem);
    }
    // if needs to be ordered
    if (typeOrder && codeOrder) {
      orderedData = [];
      // order data by type & code
        _.forEach(codeOrder, (code: any) => {
          _.forEach(typeOrder, (type: any) => {
          orderedData = [...orderedData, ..._.filter(res, {type, code})];
        });
      });
    }
    return orderedData ? orderedData : res;
  }

  private extendMarketingItem(item: any, addItem: any) {
    if (!item.description[addItem.language]) {
      item.description[addItem.language] = [];
    }
    item.description[addItem.language].push(addItem.description);
  }

  private createMarketingItem(item: any): any {
    // {
    //    code: ...
    //    description: {
    //      EN: [...],
    //      ES: [...],
    //    }
    //    assignment_code: ...
    //    assignment_title: ...
    //    title: ...
    //    type: ...
    // }
    const newItem = {...item};
    newItem.description = {};
    newItem.description[item.language] = [item.description];
    delete newItem.language;
    return newItem;
  }

  private updateSegmentsValidation() {
    this.itemDetail = setItemDetailValidation(this.itemDetail, this.selectedScorecard?.unique_id);
    // update segments validation from scoreData
    const segmentsScores = _.get(this.scoreData, 'segments');

    if (this.segmentsNavigation) {
      this.segmentsNavigation.toggleCircles((segment: any) => {
        if (this.selectedScorecard && this.selectedScorecard._id !== 'off' && segmentsScores) {
          // show red dot if segment score exists in the scorecard
          // and score is not 100%
          const segmentScore = _.get(segmentsScores, segment.segment);
          if (segment.segment === 'fitments') {
            if (_.includes(this.itemDetail.validation.segmentErrors, 'fitments')) {
              return true;
            }
          }
          if (segment.segment === 'attributes') {
            return _.includes(this.itemDetail.validation.segmentErrors, 'attributes');
          }
          if (segment.segment === 'prices') {
            if (_.includes(this.itemDetail.validation.segmentErrors, 'prices')) {
              return true;
            }
          }
        if (segmentScore) {
            return segmentScore.possible !== segmentScore.score;
          }
        }
        return false;
      });
    }
  }

  private subscribeNavsChange() {
    if (this.dynamicNavs) {
      this.dynamicNavs.changeNav
        .pipe(takeWhile(() => this.isPageActive))
        .subscribe((obj: any) => {
          if (obj.nav.name === 'logs') {
            _.defer(() => {
              obj.componentRef.instance.fetchLogs(this.brandId, this.itemId);
            });
            this.subscribeLogsRollback(obj);
            this.subscribeLogsSegmentClick(obj);
          } else if (obj.nav.name === 'comments') {
            if (this.partNumber) {
              obj.componentRef.instance.fetch(this.brandId, this.partNumber, 'item');
            }
            merge(
              obj.componentRef.instance.commentMarkedAsRead,
              obj.componentRef.instance.commentResolved
            )
              .pipe(takeWhile(() => obj.componentRef.instance.isActive))
              .subscribe(() => {
                this.setUnreadCommentsCount();
              });
          } else if (obj.nav.name === 'scorecard') {
            if (this.isItemDetailLoading) { return; }
            // render segment scorecard
            this.changeScorecard(this.activeSegment);
          }
        });
    }
  }

  private updateRightNavs(): void {
    // Comments are allowed for working and published items only
    // Logs are allowed for working items only
    this.rightPanelNavs = _.filter(rightPanelNavs, (item: any) => {
      if (!item.availableFor) { return true; } // available for all items
      return _.includes(item.availableFor, this.itemStatus);
    });
  }

  private setUnreadCommentsCount() {
    this.commentsService.getUnreadCount(this.brandId, 'item', this.partNumber)
    .subscribe((data: any) => {
      setUnreadCommentsCount(this.rightPanelNavs, data.count);
      this.ref.markForCheck();
    });
  }

  private closePage() {
    this.closingPageAnimation = true;
    this.ref.markForCheck();
    _.delay(() => {
      let returnRoute = this.returnRouteService.pop();

      // if we have previous route saved
      if (returnRoute && returnRoute.route) {
        // and it's /my-products sub-page - redirect to it
        if (returnRoute.route.indexOf('/my-products') >= 0 && indexPagesData[this.prevRouteShort]) {
          returnRoute = new ReturnRouteModel(`/my-products/${this.prevRouteShort}`, {smlocal: 1});
          this.router.navigate([`/my-products/${this.prevRouteShort}`]);
        }
      } else {
        // if we have no previous route saved
        // if we have prevRouteShort (which was formed from itemDetail.status)
        if (this.prevRouteShort && indexPagesData[this.prevRouteShort] &&
          (this.prevRouteShort === 'working' || this.prevRouteShort === 'published')) {
          returnRoute = new ReturnRouteModel(`/my-products/${this.prevRouteShort}`, {smlocal: 1});
        } else {
          // else - return on default page
          returnRoute = new ReturnRouteModel('/my-products/working', {smlocal: 1});
        }
      }

      this.router.navigate([returnRoute.route], { queryParams: returnRoute.queryParams } );
    }, 300);
  }

  private getPageUrl(): string {
    const url = this.route.snapshot.url;
    return `${url[0].path}/${url[1].path}`;
  }

  private getScoreData(): void {
    if (this.detailsPage instanceof DetailsPageModalComponent) {
      this.detailsPage.showLoader();
    }
    this.ref.markForCheck();
    forkJoin([
      this.scorecardService.getScoreItem(this.itemDetail._id, this.selectedScorecard._id),
      this.scorecardService.getScorecard(this.selectedScorecard._id),
    ])
    .pipe(takeWhile(() => this.isPageActive))
    .subscribe((data: Array<any>) => {
      this.updateSelectedScorecardProgress(data[0]);
      this.setScorecardData(data[0], data[1]);
      if (this.segmentsContainer instanceof SegmentsContainerComponent) {
        this.segmentsContainer.updateSegmentScoreData(this.scoreData, this.scorecardData);
      }
      this.updateSegmentsValidation();
      this.changeScorecard(this.activeSegment);
      if (this.detailsPage instanceof DetailsPageModalComponent) {
        this.detailsPage.hideLoader();
      }
      this.ref.markForCheck();
    });
  }

  /*
    * Every segment has it's own scorecard component
    * This method rerenders scorecard according on segment
    * If there is completion off selected, then it renders completion off stub
  */
  private changeScorecard(segment: DetailsSegment): void {
    if (this.activeTabName === 'scorecard') {
      if (!this.selectedScorecard._id || this.selectedScorecard._id === 'off') {
        this.activeTabComponent.showCompletionOff();
        return;
      }
      this.activeTabComponent.changeScorecard(
        segment,
        this.scoreData,
        this.selectedScorecard.name,
        this.itemDetail,
        this.scorecardData,
        this.priceSheets,
      );
    }
  }

  private setNavigationSegments(): void {
    if (this.bulkEdit) {
      // remove validation marks in the bulkEdit mode
      this.navigationSegments = _.map(segments, (item: any) => {
        item.circleIcon = false;
        return item;
      });
      this.navigationSegments = _.filter(this.navigationSegments, (item: any) => {
        return item.segment !== 'marketing';
      });
    }

    // filter by permissions
    this.navigationSegments = _.filter(this.navigationSegments, (item: any) => {
      if (item.segment === 'fitments') {
        // leave 'fitments' segment if user has permission
        return this.hasPermission(['admin', 'fitments', 'repository', 'catalog-view', 'catalog-edit']);
      } else {
        return this.hasPermission(['admin', 'catalog-view', 'catalog-edit', 'fitments', 'repository']);
      }
    });
  }

  private calcScorePercentage(scoreData: any): number {
    return Math.floor(scoreData.score / scoreData.possible * 100);
  }

  private setScorecard(scorecard: any) {
    this.selectedScorecard = scorecard;
    if (_.get(this.selectedScorecard, '_id') !== 'off') {
      this.getScoreData();
    } else {
      this.setScorecardData({}, {});
      // update scorecard data in the segment
      if (this.segmentsContainer instanceof SegmentsContainerComponent) {
        this.segmentsContainer.updateSegmentScoreData(this.scoreData, this.scorecardData);
      }
      if (this.activeTabName === 'scorecard') {
        this.activeTabComponent.showCompletionOff();
      }
      this.updateSegmentsValidation();
    }
  }

  private updateSelectedScorecardProgress(scoreData: any): void {
    if (!this.selectedScorecard) { return; }
    this.selectedScorecard.progress = this.calcScorePercentage(scoreData);
  }

  private setScorecardData(scoreData: any, scorecardData: any): void {
    this.scoreData = scoreData;
    // if we select completion off scorecard scoreData and scorecardData must not have any values
    if (_.size(scoreData)) {
      this.addExtInfoScoreData(scoreData);
    }
    this.scoreSourceData = _.cloneDeep(scoreData);
    this.scorecardData = scorecardData;
  }

  private addExtInfoScoreData(scoreData: any) {
    // add extendedInformation score data to scores
    const extInfoScoreData = productHelpers.getExtInfoScoreData(_.get(scoreData, 'segments.packages.tallies'));
    _.set(scoreData, 'segments.extendedInformation.tallies', extInfoScoreData);
  }

  private checkItemPermissions(itemDetail: any) {
    // check if it's not published item and user has no permission - redirect on published catalog
    if (itemDetail && itemDetail.status !== 8 && !this.hasPermission(['admin', 'catalog-edit', 'fitments'])) {
      this.router.navigate(['/my-products/published']);
    }
  }

  private rollbackFitmentsRequest(): Observable<any> {
    if (this.activeSegmentName === 'fitments') {
      return this.logsService.rollback(this.brandId, this.itemDetail.itemId, this.activeSegmentComponent.revisionId);
    } else {
      return of({});
    }
  }

  private checkUserPermission() {
    if (!this.permissionsService.hasPermission(['fitments', 'admin', 'repository', 'catalog-view', 'catalog-edit'])) {
      this.router.navigate(['/logout']);
    }
  }
}
